module.exports = __webpack_public_path__ + "img/for-artists-mobile.6c5e4f5d.svg";